/**
 * shipping-page.js
 * Shared JavaScript for all Shipping Page sections.
 * No jQuery. No inline JS. Vanilla ES6+.
 */

'use strict';

/* ============================================================
   Utility: Intersection Observer for scroll reveal
   ============================================================ */
function initScrollReveal() {
  if (!('IntersectionObserver' in window)) {
    // Fallback: show everything immediately
    document.querySelectorAll('.sp-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.sp-reveal').forEach(function (el) {
    observer.observe(el);
  });
}

/* ============================================================
   Timeline: animate steps on scroll
   ============================================================ */
function initTimeline() {
  var steps = document.querySelectorAll('.sp-timeline__step');
  if (!steps.length) return;

  if (!('IntersectionObserver' in window)) {
    steps.forEach(function (s) { s.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  steps.forEach(function (step) { observer.observe(step); });
}

/* ============================================================
   FAQ Accordion
   ============================================================ */
function initFaq() {
  var faqList = document.querySelector('.sp-faq__list');
  if (!faqList) return;

  var items = faqList.querySelectorAll('.sp-faq__item');

  items.forEach(function (item) {
    var trigger = item.querySelector('.sp-faq__trigger');
    if (!trigger) return;

    trigger.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');

    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      // Close all other items
      items.forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('.sp-faq__trigger');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle current item
      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    });

    // Keyboard: open/close with Enter / Space (already handled by click on button)
  });
}

/* ============================================================
   Freight Rates: Card / Table toggle
   ============================================================ */
function initFreightToggle() {
  var toggleBtns = document.querySelectorAll('.sp-freight__toggle-btn');
  if (!toggleBtns.length) return;

  var cardView  = document.querySelector('.sp-freight__cards');
  var tableView = document.querySelector('.sp-freight__tables');

  toggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var layout = btn.dataset.layout;

      toggleBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      if (layout === 'cards') {
        if (cardView)  cardView.removeAttribute('hidden');
        if (tableView) tableView.setAttribute('hidden', '');
      } else {
        if (tableView) tableView.removeAttribute('hidden');
        if (cardView)  cardView.setAttribute('hidden', '');
      }
    });
  });
}

/* ============================================================
   Hero: animate on load
   ============================================================ */
function initHeroAnimation() {
  var hero = document.querySelector('.sp-hero');
  if (!hero) return;

  // Elements are animated via CSS sp-animate classes with delays
  // Nothing extra needed — this hook is for future extensibility.
}

/* ============================================================
   Init on DOM ready
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  initScrollReveal();
  initTimeline();
  initFaq();
  initFreightToggle();
  initHeroAnimation();
});